import React from 'react'
import {
  func,
} from 'prop-types'

import {
  Icon,
  Notice as NoticeComponent,
  InfoFilled,
} from '@cgtrader/triangle-ui/dist/src/ssr-index'

const noticeAction = (
  <a
    type="secondary"
    href="/designers"
    target="_self"
  >
    Top Designers
  </a>
)

const icon = <Icon color="dark" size="medium" svgComponent={InfoFilled} />

const message = (
  <div>
    <span>
      You are not following any designers yet.
      Explore CGTrader's top designers, start following them,
      and easily discover content from your favorite creators.{' '}
    </span>
    {noticeAction}
  </div>
)

function FollowingNotice({ onClose }) {
  return (
    <div className="col-12">
      <NoticeComponent
        type="primary"
        useSSRIcon
        onClose={onClose}
        ssrIcon={icon}
        className="cgt-mb-20"
      >
        {message}
      </NoticeComponent>
    </div>
  )
}

FollowingNotice.propTypes = {
  onClose: func.isRequired,
}

export default FollowingNotice
